export const SELECTOPTIONS = [
  { label: "Tumorigenesis", value: "Tumorigenesis" },
  { label: "Survival", value: "Survival" },
  { label: "Proliferation", value: "Proliferation" },
  { label: "Drug Sensitivity", value: "Drug_Sensitivity" },
  { label: "Selected Pathway", value: "Pathway" },
  { label: "Centrality", value: "Centrality" },
  { label: "Recommended gene list for drug discovery using CMap/PharmOmics", value: "Significant_Condition" },
];

export const SIGNIFICANT_OPTIONS = [
  "Consistently Significant",
  "Not Conflict",
  "Any Significant",
];


export const TUMORIGENESIS_PAIRED_OPTIONS = [
  { value: "true", label: "Paired Analysics (Analyze using paired patient samples only)" },
  { value: "false", label: "UnPaired Analysics (Analyze using all patient samples)" }
];


export const CHECKBOX_GROUPS = [
  {
    title: "TCGA",
    category: "tcga",
    options: ["Tumorigenesis", "Survival"],
  },
  {
    title: "CCLE",
    category: "ccle",
    options: ["Proliferation", "Drug Sensitivity"],
  },
];

export const CENTRALITYOPTIONS = [
  { value: "degree_centrality", label: "Degree Centrality" },
  { value: "in_degree_centrality", label: "In-Degree Centrality" },
  { value: "out_degree_centrality", label: "Out Degree Centrality" },
  { value: "eigenvector_centrality", label: "Eigenvector Centrality" },
  { value: "closeness_centrality", label: "Closeness Centrality" },
  { value: "betweenness_centrality", label: "Betweenness Centrality" },
  { value: "voterank_centrality", label: "Voterank Centrality" },
]